import './App.css';
import React, {Fragment,useEffect,useState} from 'react';
import AppWrapper from './components/AppWrapper';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import {RecoilRoot} from 'recoil';

function App() {
return (
        <Fragment>  
            <HelmetProvider>
                <Helmet>
                    <title>Tunisie</title>
                </Helmet>
                <RecoilRoot>
                    <AppWrapper />
                </RecoilRoot>
                </HelmetProvider>  
        </Fragment>
    );
}

export default App;
